module.exports = __webpack_public_path__ + "img/fig1.05671ba4.png";